import { IOptionsWithTypes } from "@eventr/common";
import { ColoursObj, Typography } from "@eventr/common-storybook";
import { useMemo } from "react";
import { useShallow } from "zustand/react/shallow";
import { useBoundStore } from "../../state/bound.store";
import { ICondition } from "./shouldRender";
interface ICountLabelProps {
  id?: string;
  data: any;
  renderOptions: ICounterOptions;
}

interface ICounterOptions {
  list: string;
  subList?: string;
  conditions?: ICondition[];
}

export const Counter = ({ id, data, renderOptions }: ICountLabelProps) => {
  const { getUsersWithTags, doesUserExist } = useBoundStore(
    useShallow((s) => {
      return {
        getUsersWithTags: s.getUsersWithTags,
        doesUserExist: (userId: number) => s.users?.some((u) => u.id === userId),
      };
    }),
  );

  const count = useMemo(() => {
    let count = 0;
    if (renderOptions.subList) {
      count = (data[renderOptions.list] || []).reduce((acc: number, curr: any) => {
        return (
          acc +
          ((renderOptions.subList && curr[renderOptions.subList]) || []).reduce(
            (acc: number, curr: IOptionsWithTypes) => {
              if (curr.type === "Group") {
                return acc + getUsersWithTags([], [curr.option as string]).length;
              }
              if (curr.type === "Department") {
                return acc + getUsersWithTags([curr.option as string], []).length;
              }

              if (doesUserExist(curr.option as number)) return acc + 1;
              return acc;
            },
            0,
          )
        );
      }, 0);
    } else {
      /// Reduce to count inner of .users (idk why)
      /// i added the '' to add 1 for each user value. idk what the logic was before to make this work...
      count = (data[renderOptions.list] || []).reduce((acc: number, curr: any) => {
        if (doesUserExist(curr.option as number)) return acc + 1;
        return acc;
      }, 0);
    }
    return count;
  }, [data, renderOptions, doesUserExist, getUsersWithTags]);

  return (
    <Typography
      id={id + "counter"}
      sx={{
        padding: "4px 8px",
        gap: "8px",
        borderRadius: "4px",
        background: "#EDF3F4",
        lineHeight: "16px",
        fontWeight: "300",
        fontSize: "12px",
        backgroundColor: ColoursObj.core.secondary,
        color: ColoursObj.backgrounds.primary,
      }}
      variant="bodyBold"
    >
      {count.toString() ?? "0"}
    </Typography>
  );
};
